//#region header */
/**************************************************************************************************
//
//  Description: GAAAssociatedStreetDataListContext
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   21.03.21 Peter Bryden        WI39243 Add context to hold state of treelist open states
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */
import React, { useState, useContext, createContext, useEffect } from "react";


const ListStateContext = createContext();
const ListStateUpdateContext = createContext();

export function useAAAssociatedStreetDataListState() { return useContext(ListStateContext); }
export function useAAAssociatedStreetDataUpdateState() { return useContext(ListStateUpdateContext); }

export function AAAssociatedStreetDataListContextProvider({ children }) {

  const [open, setOpen] = useState({});


  function toggleOpen(name)
  {
    let newOpen = open;
    newOpen[name] = !open[name];
    setOpen(newOpen);
  }

  function getOpen(name) {
    if (open[name] === undefined) {
      let newOpen = open;
      newOpen[name] = true;
      setOpen(newOpen);
		}

    return open[name];
}

  useEffect(() => {
  }, [open]);

  return (
    <ListStateContext.Provider value={getOpen}>
      <ListStateUpdateContext.Provider value={toggleOpen }>
      {children}
      </ListStateUpdateContext.Provider>
    </ListStateContext.Provider>
  );
}





